// @flow

import saveOrder from '../../../Services/saveOrder';
import onClickSaveProcurementItems from '../../../Handlers/onClickSaveProcurementItems';

export default () => async (dispatch: Function) => {
  
  // Save procurement items first
  await dispatch(onClickSaveProcurementItems());
  
  // Then save order items and caveats
  await dispatch(saveOrder());
  
}